export enum VehicleSource {
  CAR_TRACK = 'CAR_TRACK',
  USER = 'USER',
  SERVICE_PROVIDER = 'SERVICE_PROVIDER',
}
